module.exports = "<svg width=\"10\" height=\"21\" viewBox=\"0 0 10 21\" xmlns=\"http://www.w3.org/2000/svg\"><title>down-arrow</title><path d=\"M9.508 14.752H6.42V.877h-3v13.875H.331a.208.208 0 0 0-.16.34l4.59 5.55c.082.1.236.1.32 0l4.588-5.55a.208.208 0 0 0-.16-.34\" fill=\"#FEFEFE\" fill-rule=\"evenodd\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/icons/down-arrow.svg
// module id = ./node_modules/raw-loader/index.js!./src/icons/down-arrow.svg
// module chunks = 168707334958949